<template>
  <div class="big mydialog">
    <div class="page_title flex_between">
      <span>添加医生和上限设置</span>
      <el-button
        type="primary"
        size="medium"
        style="width: 92px"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <el-button
            type="primary"
            @click="adddialog"
          >添加医生</el-button>
          <span style="margin:0 10px 0 30px">已选医生：{{choose_doctor.length}}人</span>
          <el-button
            type="text"
            @click="removeDoctor"
          >清除</el-button>
        </div>
        <div style="margin:25px 0 10px;font-weight:700">
          设置诊后管理费上限
        </div>
        <div style="border: solid 1px #c9cbd6;width: 800px">
          <el-table
            ref="multipleTable"
            :data="drugtypeData"
            tooltip-effect="dark"
            style="width: 800px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column width="50">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.is_check"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              label="剂型名称"
              prop="drug_type_name"
            >
            </el-table-column>
            <el-table-column
              prop="drug_type_pid_str"
              label="剂型分类/药品类型"
            >
            </el-table-column>
            <el-table-column
              prop="hospital"
              label="诊后管理费上限"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.proportion"
                  :precision="2"
                  :step="0.01"
                  :max="9999"
                  :min="0"
                  :controls="false"
                  size="small"
                  :disabled="!scope.row.is_check"
                  style="width:100px"
                />
              </template>

            </el-table-column>
          </el-table>
        </div>
        <div style="width:800px;text-align:center;margin-top:30px">
          <el-button
            type="primary"
            @click="publish"
            style="width:120px"
            size="medium"
          >确定</el-button>
          <el-button
            plain
            @click="back"
            style="width:120px"
            size="medium"
          >取消</el-button>
        </div>
      </div>
    </div>
    <!-- 设置医生弹窗 -->
    <el-dialog
      title="选择医生"
      :visible.sync="adddoctor"
      width="740px"
      :close-on-click-modal="false"
      :before-close="closeDia"
    >
      <div>
        <div
          class="searchbox"
          style="padding-left:15px"
        >
          <div class="item">
            <span class="itemtitle">医生姓名</span>
            <el-input
              v-model="doctor_name"
              size="medium"
              style="width: 120px"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">手机号</span>
            <el-input
              v-model="doctor_phone"
              size="medium"
              style="width: 120px"
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span class="itemtitle">医院名称</span>
            <el-input
              v-model="hospital"
              size="medium"
              style="width: 120px;margin-right:10px"
              @change="search"
            ></el-input>
            <el-button
              type="primary"
              @click="search"
              size="medium"
            >查询</el-button>
          </div>
        </div>
        <div style="padding: 0 25px">
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="doctorData"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column
                label="医生姓名"
                prop="doctor_name"
                width="130"
              >
              </el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                width="150"
              ></el-table-column>
              <el-table-column
                prop="hospital"
                label="医院"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div>
          <el-pagination
            @size-change="doctorSizeChange"
            @current-change="doctorCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 10px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
      <div style="padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="setDoctor"
            size="medium"
          >添加，并继续查询</el-button>
          <el-button
            plain
            @click="closeDia"
            size="medium"
          >取消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  data() {
    return {
      hospital_id: this.$route.query.hospital_id,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      allDoctor: 0,
      choose_doctor: [],
      drugtypeData: [],
      content: '',
      is_send: 1,
      doctorData: [],
      adddoctor: false,
      selection: '',
      doctor_name: '',
      doctor_phone: '',
      hospital: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getDrugTypeList();
  },
  methods: {
    //获取剂型列表
    getDrugTypeList() {
      let hospital_id = this.hospital_id;
      this.axios
        .post('platform/Drugtype/getDrugHospitalList', { hospital_id })
        .then((res) => {
          if (res.code == 0) {
            this.drugtypeData = res.data.list.map((item) => {
              item.is_check = false;
              item.proportion = undefined;
              return item;
            });
          }
        });
    },

    //添加医生弹窗
    adddialog() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.doctor_name = '';
      this.doctor_phone = '';
      this.hospital = '';
      this.adddoctor = true;
      this.getDoctorList();
    },
    //查询医生
    getDoctorList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        hospital: this.hospital,
        auth_status: 2
      };
      this.axios.post('platform/doctor/doctorList', data).then((res) => {
        if (res.code == 0) {
          this.doctorData = res.data.list;
          this.totalNum = res.data.total;
        }
      });
    },
    //多选
    handleSelectionChange(val) {
      let selection = [];
      selection = val.map((item) => {
        return item.doctor_id;
      });
      this.selection = selection;
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getDoctorList();
    },
    //选择医生每页数据的条数
    doctorSizeChange(size) {
      this.pagesize = size;
      this.getDoctorList();
    },
    //选择医生当前第几页
    doctorCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getDoctorList();
    },
    //设置医生
    setDoctor() {
      if (!this.selection.length) {
        this.$message.error('请先选择添加的医生');
        return false;
      }
      let choose_doctor = this.choose_doctor.concat(this.selection);
      this.choose_doctor = Array.from(new Set(choose_doctor));
    },
    //关闭弹窗
    closeDia() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.selection = '';
      this.adddoctor = false;
    },
    //移除医生
    removeDoctor() {
      this.choose_doctor = [];
    },
    //发布
    publish() {
      if (!this.choose_doctor.length) {
        this.$message.error('请先添加医生');
        return false;
      }
      let typeArr = [];
      this.drugtypeData.map((item) => {
        if (item.is_check && item.proportion >= 0) {
          let data = {};
          data = _.pick(item, ['drug_type', 'proportion']);
          typeArr.push(data);
        }
      });
      if (!typeArr.length) {
        this.$message.error('没有符合规则的诊后管理费设置');
        return false;
      }
      let loading = this.$loading();
      let hospital_drug = [];
      for (let i = 0; i < typeArr.length; i++) {
        for (let j = 0; j < this.choose_doctor.length; j++) {
          let data = {};
          data.doctor_id = this.choose_doctor[j];
          data.drug_type = typeArr[i].drug_type;
          data.proportion = typeArr[i].proportion;
          hospital_drug.push(data);
        }
      }
      let data = {
        hospital_id: this.hospital_id,
        hospital_drug: hospital_drug
      };
      this.axios
        .post('platform/hospital/setDoctorHospitalProportionNew', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('设置成功');
            this.back();
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 5px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      margin-left: 10px;
      display: inline-block;
      text-align: right;
      margin-right: 5px;
    }
  }
}
</style>
